import {
  GetProfileResponse,
  Profile,
  UpdateUserPasswordRequest,
  UpdateUserRequest,
} from '../../../models/user.models';
import { BuilderType, InvalidationTag, mlkOnQueryStarted } from '../../utils';

export const buildUpdateProfile = (builder: BuilderType) =>
  builder.mutation<undefined, UpdateUserRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: `/user/profile`,
      method: 'PATCH',
      body,
    }),
    invalidatesTags: () => [{ type: InvalidationTag.User }],
  });

export const buildGetProfile = (builder: BuilderType) =>
  builder.query<Profile, undefined>({
    onQueryStarted: mlkOnQueryStarted,
    query: () => `/user/profile`,
    transformResponse: (res: GetProfileResponse) => res.user,
    providesTags: () => [{ type: InvalidationTag.User }],
  });

export const buildUpdatePassword = (builder: BuilderType) =>
  builder.mutation<{}, UpdateUserPasswordRequest>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({ url: `/user/password`, method: 'PATCH', body }),
  });
